import React, { useState, useEffect } from "react";
import classes from "./Message.module.scss";
import PropTypes from "prop-types";
import cl from "classnames";
import { connect } from "formik";
import formikShape from "../../shapes/formik.js";

function Message({ classname, name, value, formik, children }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(formik.values[name] === value);
  }, [formik.values[name]]);
  return (
    <p className={cl(classes.message, { [classes.show]: show }, classname)}>
      {children}
    </p>
  );
}

Message.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  classname: PropTypes.string,
  formik: formikShape,
  children: PropTypes.node,
};
export default connect(({ formik, ...props }) => {
  return <Message formik={formik} {...props} />;
});
